import React, { useState, useEffect } from "react";
import { Card, Table, Space, message } from "antd";
import GainIcon from "../../components/gainicon";
import CardTitleFilter from "../../components/objects/CardTitle";
import GainModal from "../../components/objects/GainModal";
import Update from "./update";
import { MomentFormat } from "../../tools";

import { getScenarios, deleteScenario } from "../../services/api";
import EditButton from "../../components/objects/EditButton";
import DeleteButton from "../../components/objects/DeleteButton";

import { useHistory } from "react-router-dom";
import { Search, Sort } from "../../tools";

export default function Scenario() {
  let history = useHistory();

  const [ModalVisible, setModalVisible] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [data, setData] = useState([]);
  const [dataSource, setdataSource] = useState([]);
  const [dataUpdate, setdataUpdate] = useState(null);
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    scenarioLists();
  }, []);

  const scenarioLists = async () => {
    setLoading(true);
    const res = await getScenarios();
    if (res.status === 200) {
      setData(res.data);
      setdataSource(res.data);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Scenario ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Scenario name",
      dataIndex: "scenario_name",
      key: "scenario_name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Owner",
      dataIndex: ["owner", "firstname"],
      key: "owner",
    },
    {
      title: "Update",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (text) => MomentFormat(text),
    },
    {
      title: "",
      dataIndex: "id",
      key: "id",
      render: (id) => (
        <Space>
          <EditButton onClick={() => onEdit(id)} />
          <DeleteButton onClick={() => onDelete(id)} />
        </Space>
      ),
    },
  ];

  const onEdit = (id) => {
    const res = dataSource.filter((item) => item.id == id);
    setdataUpdate(...res);
    setModalVisible(true);
  };

  const onDelete = async (e) => {
    let payload = "";
    if (typeof e !== "number") {
      const ids = e.map((item) => {
        return `ids[]=${item}`;
      });
      payload = ids.join("&");
    } else {
      payload = `ids[]=${e}`;
    }

    const res = await deleteScenario(payload);
    if (res.status === 200) {
      message.success("Deleted");
      scenarioLists();
      setSelectedRowKeys([]);
    } else {
      message.error("Delete Failed");
    }
  };

  const pagiOptions = {
    total: dataSource?.length,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  };

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  return (
    <div>
      <h1 className="text-3xl font-bold">Scenario</h1>
      <Card
        title={
          <CardTitleFilter
            filterOptions={columns}
            addLabel="New scenarios"
            onAdd={() => history.push("/data-management")}
            onSearch={(keyword) => {
              const dataSearch = Search(data, keyword);
              setdataSource(dataSearch);
            }}
            onSort={(dataIndex) => {
              const dataSort = Sort(data, dataIndex);
              setdataSource(dataSort);
            }}
          />
        }
        className="border-none rounded-lg rounded-b-none"
      >
        <Table
          rowSelection={rowSelection}
          dataSource={dataSource}
          columns={columns}
          pagination={pagiOptions}
          rowKey="id"
        />
        {hasSelected && (
          <div className="absolute bottom-2.5 pl-5 text-gray-400 font-light">
            <span className="pr-3">{`${selectedRowKeys.length} Item seleted`}</span>
            <span
              className="cursor-pointer"
              onClick={() => onDelete(selectedRowKeys)}
            >
              <GainIcon name="trash-circle" />
            </span>
          </div>
        )}
      </Card>
      <GainModal
        title="New scenarios"
        visible={ModalVisible}
        onClose={() => setModalVisible(false)}
      >
        <Update
          data={dataUpdate}
          onFinish={() => {
            setModalVisible(false);
            scenarioLists();
          }}
        />
      </GainModal>
    </div>
  );
}
